import { Component, Input, inject, input } from '@angular/core';
import { CommonModule, Location } from '@angular/common';
import { Person, AvatarsComponent } from '@libs/ui-lib';
import { TranslateModule } from '@ngx-translate/core';
import { SvgIconComponent } from '@ngneat/svg-icon';
import { Router, RouterModule } from '@angular/router';
import { routes } from '@libs/utils';
import { CdkMenuModule } from '@angular/cdk/menu';
import { TokenService } from '@libs/shared-services';
import { SiteSetupComponentService, stepOrder } from '../../site-setup.component.service';

@Component({
  selector: 'lib-site-setup-navbar',
  imports: [CommonModule, AvatarsComponent, TranslateModule, SvgIconComponent, RouterModule, CdkMenuModule],
  templateUrl: './site-setup-navbar.component.html',
  styleUrl: './site-setup-navbar.component.scss',
})
export class SiteSetupNavbarComponent {
  @Input({ required: true }) public loggedInUser: Person | null = null;
  @Input() public hasBackButton?: boolean = true;
  @Input() public stepNumber: number = 0;
  @Input() public stayOnCurrent: boolean = false;
  @Input() public useLocationNavigation: boolean = false;
  public isNewModalDesign = input<boolean>(false);
  public hasUserProfile = input<boolean>(true);
  public badgeTranslationKey = input<string>('site_setup_contract_install_now');

  public siteSetupComponentService = inject(SiteSetupComponentService);
  private readonly router = inject(Router);
  private readonly tokenService = inject(TokenService);
  private readonly location = inject(Location);

  public vm = this.siteSetupComponentService.viewModel;

  public routes = routes;

  public back(): void {
    if (this.useLocationNavigation) {
      this.location.back();
      return;
    }

    const newStepNumber = this.stayOnCurrent ? this.stepNumber : this.stepNumber - 1;
    this.siteSetupComponentService.setActiveStep(newStepNumber);
    if (this.stepNumber > 2) {
      this.router.navigate([routes.setup, ...stepOrder[newStepNumber - 1]]);
    } else {
      this.router.navigate([routes.site, routes.showcaseSiteId, routes.home]);
    }
  }

  public onLogOutClick(): void {
    this.tokenService.logout();
  }
}
